/** API base: api.<this host> in the cloud (dev.firstmango.com -> api.dev.firstmango.com); VITE_API_URL locally. */
export function apiBase(): string {
  const env = import.meta.env.VITE_API_URL as string | undefined;
  if (env) return env.replace(/\/$/, '');
  const host = location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') return 'https://api.dev.firstmango.com';
  return `https://api.${host}`;
}

export class ApiError extends Error {
  constructor(readonly status: number, readonly code: string, message: string) {
    super(message);
  }
}

export async function api<T = unknown>(method: string, path: string, opts: { token?: string; body?: unknown } = {}): Promise<T> {
  let res: Response;
  try {
    res = await fetch(`${apiBase()}${path}`, {
      method,
      headers: {
        ...(opts.token ? { authorization: `Bearer ${opts.token}` } : {}),
        ...(opts.body !== undefined ? { 'content-type': 'application/json' } : {}),
      },
      body: opts.body !== undefined ? JSON.stringify(opts.body) : undefined,
    });
  } catch {
    throw new ApiError(0, 'offline', 'No connection. Check the Wi-Fi and try again.');
  }
  const json = (await res.json().catch(() => ({}))) as { error?: string; message?: string };
  if (!res.ok) throw new ApiError(res.status, json.error ?? 'error', json.message ?? 'Something went wrong');
  return json as T;
}

export interface PublicConfig { region: string; userPoolId: string; clientId: string; loginUrl: string; wsUrl: string; mediaUrl: string }
let config: Promise<PublicConfig> | undefined;
export const getConfig = () => (config ??= api<PublicConfig>('GET', '/config'));
